import { faXmark as CancelIcon } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '@mui/material/IconButton';
import { useAtom } from 'jotai';
import { useMemo, useState } from 'react';

import {
  ENV_ALERT_GREEN,
  ENV_ALERT_PINK,
  ENV_ALERT_YELLOW
} from '@/constants/colors.constants';
import { ENV_DEV, ENV_QA, ENV_STG } from '@/constants/common';
import useFetchEnvironment from '@/pages/Administration/Administration.hooks';
import { envAtom } from '@/pages/Administration/Administration.store';

import useStyles from './EnvironmentAlert.styles';

const EnvironmentAlert = () => {
  const environment = useFetchEnvironment();
  const [env] = useAtom(envAtom);
  // Dismissal applies only to the environment data it was made against.
  const [dismissed, setDismissed] = useState<{ data: unknown } | null>(null);

  const backgroundColor = useMemo(() => {
    switch (env) {
      case ENV_DEV:
        return ENV_ALERT_YELLOW;
      case ENV_QA:
        return ENV_ALERT_GREEN;
      case ENV_STG:
        return ENV_ALERT_PINK;
      default:
        return '#fff';
    }
  }, [env]);
  const { classes } = useStyles({ backgroundColor });

  const isEnvironmentAlertDisplayed =
    environment?.data?.env !== 'production' &&
    dismissed?.data !== environment.data;

  // closes alert
  const handleClick = () => {
    setDismissed({ data: environment.data });
  };

  const IS_ENVIRONMENT_WITH_ALERT =
    env === ENV_DEV || env === ENV_QA || env === ENV_STG;

  return (
    <>
      {isEnvironmentAlertDisplayed && IS_ENVIRONMENT_WITH_ALERT && (
        <div className={classes.environmentAlert}>
          <div />
          <div>
            You are viewing <b>{env}</b>
          </div>
          <IconButton
            className={classes.environmentAlertCancelIcon}
            onClick={handleClick}
          >
            <FontAwesomeIcon size="2xs" icon={CancelIcon} />
          </IconButton>
        </div>
      )}
    </>
  );
};

export default EnvironmentAlert;
